module.exports = __webpack_public_path__ + "img/img1.35637c09.png";